import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import { desktopOnly, mobileOnly } from 'styles/mixins/displayMobileDesktop';
import { type HeroPopProps } from '../HeroPop';

export const POP_REDESIGN_HERO_CONTENT: HeroPopProps = {
  images: (
    <React.Fragment>
      <StaticImage
        src="../images/mobileHeroSept@2x.jpg"
        alt="Four Curology products — Gentle Cleanser, Cream Moisturizer, Everyday Sunscreen (spf 30) and Emergency Spot Patches —  against a beige background"
        css={[mobileOnly('block', 'mdUp')]}
        loading="eager"
        objectFit="fill"
        objectPosition="center"
      />
      <StaticImage
        src="../images/squeezeDesktopHero.png"
        alt="Four Curology products — Gentle Cleanser, Cream Moisturizer, Everyday Sunscreen (spf 30) and Emergency Spot Patches —  against a beige background"
        css={[desktopOnly('block', 'mdUp')]}
        loading="eager"
        objectFit="fill"
        objectPosition="bottom"
      />
    </React.Fragment>
  ),
  title: 'Discover the power of personalized skincare',
  subtitle: 'Start your journey to clearer skin today.',
  efficacyStats: [
    {
      animation: {
        start: 89,
        end: 93,
      },
      postfix: '%',
      label: 'report effective*',
    },
    {
      animation: {
        start: 1,
        end: 5,
      },
      postfix: 'M+',
      label: 'patients treated',
    },
    {
      animation: {
        start: 5,
        end: 9,
      },
      postfix: 'K+',
      label: '5-star reviews',
      superscriptSymbol: '▵',
    },
  ],
  ctaButton: {
    buttonText: 'Get my formula',
  },
  heroClass: 'personalizedSkincare',
};

export const RETAIL_OFFER_HERO_CONTENT: HeroPopProps = {
  images: (
    <React.Fragment>
      <StaticImage
        src="../images/retailOfferHeroMobile@2x.jpg"
        alt="Four Curology products — Gentle Cleanser, Cream Moisturizer, Everyday Sunscreen (spf 30) and Emergency Spot Patches —  against a beige background"
        css={[mobileOnly('block', 'mdUp')]}
        loading="eager"
        objectFit="fill"
        objectPosition="center"
      />
      <StaticImage
        src="../images/retailOfferHeroDesktop.png"
        alt="Four Curology products — Gentle Cleanser, Cream Moisturizer, Everyday Sunscreen (spf 30) and Emergency Spot Patches —  against a beige background"
        css={[desktopOnly('block', 'mdUp')]}
        loading="eager"
        objectFit="fill"
        objectPosition="bottom"
      />
    </React.Fragment>
  ),
  title: 'Get Your <span class="orange">FREE*</span> Personalized Skincare',
  subtitle: 'Redeem your exclusive offer worth over $50 today.',

  ctaButton: {
    buttonText: 'Claim your free product',
  },
  heroClass: 'retailOffer',
  disclaimer:
    '*Subject to medical consultation. Subscription required. Just pay $4.95 for shipping and handling. New subscribers only. Applies only to your first box. First box lasts 30 days. Add-ons available. Only prescription products are customized. Restrictions apply.',
};
